// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__3I59d","navbar__name":"Navbar_navbar__name__gZS5e","navbar__links":"Navbar_navbar__links__22_1B"};